import { Button } from "@/ui-components/button-with-loading";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/24/solid";
import clsx from "clsx";
import React from "react";
import { Control, useController } from "react-hook-form";
import SimpleMdeReact from "react-simplemde-editor";

type PropType = {
  initialValue?: string;
  defaultOpen?: boolean;
  control: Control;
  label: string;
  name: string;
  secondaryLabel?: string;
};

function AccordianField(props: PropType) {
  const { field } = useController({ name: props.name, control: props.control });

  return (
    <div className="flex flex-col gap-y-2 col-span-2">
      <Disclosure defaultOpen={props.defaultOpen}>
        {({ open }) => (
          <>
            <DisclosureButton
              as={Button}
              variant="secondary"
              renderIcon={() => (
                <ChevronUpIcon
                  className={clsx("size-4 order-2 ", open && "rotate-180")}
                />
              )}
              className={"justify-between "}
            >
              <span className="flex items-center gap-2">
                {props.label}
                <span className="text-xs font-normal text-gray-400">
                  {props.secondaryLabel}
                </span>
              </span>
            </DisclosureButton>

            <DisclosurePanel>
              <SimpleMdeReact
                className={"bg-gray-100 rounded-md overflow-hidden"}
                onChange={field.onChange}
                value={props.initialValue ?? field.value}
              />
              <input type="hidden" name={field.name} value={field.value} />
            </DisclosurePanel>
          </>
        )}
      </Disclosure>
    </div>
  );
}

export default AccordianField;
